import { Controller, useFormContext } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import { cloneElement } from 'react'

interface FormInputProps {
  name: string
  className?: string
  inputFieldComponent: React.ReactElement
  manualOnchange?: boolean
}

const FormInput: React.FC<FormInputProps> = ({
  name,
  className = '',
  inputFieldComponent,
  manualOnchange = false,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <div className={className}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange: updateValueOnChange, value } }) =>
          cloneElement(inputFieldComponent, {
            updateValueOnChange: manualOnchange ? undefined : updateValueOnChange,
            value,
          })
        }
      />
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) =>
          message && (
            <p className={'text-status-negative leading-[22px] font-normal ml-1 mt-1.5 text-sm'}>
              {message}
            </p>
          )
        }
      />
    </div>
  )
}

export default FormInput
